import { Icons, TooltipColor } from '../enums';
import strings from '../language/Swedish';
import Icon from './Icon';
import TooltipInfo from './TooltipInfo';
import { formatPrice } from '../helpers';
import styled from 'styled-components';
import tw from 'twin.macro';
import { FC } from 'react';

const RefPriceTooltip = styled.div<{ $color: TooltipColor }>`
  ${tw`flex items-center text-nowrap gap-1 px-2 py-1 text-xs leading-[0] border rounded-full`}

  ${({ $color }) =>
    $color === TooltipColor.primary
      ? tw`bg-primary/15 border-primary/50 text-primary`
      : tw`bg-slate-800/95 border-slate-800 text-neutral-50`}
`;

interface Props {
  color: TooltipColor;
  referencePrice?: number | null;
  referencePriceSqm?: number | null;
  content?: string;
  className?: string;
}

const TooltipReferencePrice: FC<Props> = ({
  color,
  referencePrice,
  referencePriceSqm,
  content,
  className,
}) => (
  <div className={className}>
    {referencePrice &&
      referencePrice !== 0 &&
      referencePrice !== referencePriceSqm && (
        <TooltipInfo
          content={content || strings.priceDevelopment.refPriceBasedOnDefault}
        >
          <RefPriceTooltip $color={color}>
            <Icon
              icon={color === TooltipColor.primary ? Icons.check : Icons.list}
            />
            <span className="font-medium">{`${formatPrice(referencePrice)} ${strings.priceDevelopment.priceCurrency}`}</span>
            {referencePriceSqm && (
              <span>{`(${formatPrice(referencePriceSqm)} ${strings.priceDevelopment.pricePerSqm})`}</span>
            )}
          </RefPriceTooltip>
        </TooltipInfo>
      )}
  </div>
);

export default TooltipReferencePrice;
